import { client } from '@/client';
import { LearnerCourseDispatchResponse } from '@/client/learner-course/types/learner-course.type';
import { SCORM_DISPATCH_URL_QUERY_KEY } from '@/hooks/query/courses.query-keys';
import { useQuery, UseQueryOptions, UseQueryResult } from 'react-query';

export const useScormDispatchUrl = (
  params: UseQueryOptions & {
    courseId?: string;
    resourceId?: string;
    language?: string;
  },
): UseQueryResult<LearnerCourseDispatchResponse> & {
  scormDetails: LearnerCourseDispatchResponse | undefined;
} => {
  const {
    courseId,
    resourceId,
    language,
    retry = false,
    retryDelay = 500,
    staleTime = 0,
    cacheTime = 0,
    ...restOptions
  } = params;

  const { data, ...rest } = useQuery(
    [SCORM_DISPATCH_URL_QUERY_KEY, courseId, resourceId, language],
    () =>
      courseId && resourceId && language
        ? client.courses.getResourceDispatchUrl(courseId, resourceId, language)
        : undefined,
    {
      enabled: !!courseId && !!resourceId && !!language,
      retry,
      retryDelay,
      staleTime,
      cacheTime,
      ...(restOptions as UseQueryResult<LearnerCourseDispatchResponse>),
    },
  );

  return {
    scormDetails: data,
    ...(rest as UseQueryResult<LearnerCourseDispatchResponse>),
  };
};
